/* eslint-disable @stylistic/max-len */
import React from 'react';
import propTypes from './propTypes';

const GardenBeet = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="13"
    height="19"
    fill="none"
    viewBox="0 0 13 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.31919 18.2616C5.73119 18.2616 5.44079 17.808 5.10959 16.9704C4.63199 15.7416 4.224 15.2592 2.9256 14.3952C1.8792 13.6992 1.2408 13.1424 0.789599 12.5376C0.2496 11.8128 0 11.0232 0 10.056C0 8.94481 0.429599 7.96801 1.2432 7.23121C2.0544 6.49681 3.2424 6.00481 4.67759 5.80561L4.85039 5.78161L2.7576 1.9896L4.01279 1.2912L5.56319 4.0968L5.64239 0L7.08479 0.0216001L7.00559 4.29841L8.30639 2.0592L9.53999 2.7792L7.80719 5.77921L7.98239 5.80561C9.41999 6.01681 10.6032 6.51121 11.4048 7.24081C12.2208 7.98241 12.636 8.92801 12.636 10.056C12.636 11.0232 12.384 11.8128 11.8464 12.5376C11.3952 13.1424 10.7568 13.6992 9.71039 14.3952C8.41199 15.2592 8.00399 15.7416 7.52639 16.9728C7.19759 17.808 6.90719 18.2616 6.31919 18.2616ZM6.31919 7.19761C4.83599 7.19761 3.612 7.46881 2.7816 7.98001C1.968 8.48161 1.5384 9.19921 1.5384 10.0536C1.5384 11.5536 2.4984 12.2328 3.6096 13.0152C4.50719 13.6488 5.52719 14.3688 6.21359 15.6768L6.31919 15.8784L6.42479 15.6768C7.11119 14.3688 8.12879 13.6512 9.02879 13.0152C10.14 12.2304 11.1 11.5536 11.1 10.0536C11.1 9.19921 10.6704 8.48161 9.85679 7.98001C9.02639 7.46881 7.80239 7.19761 6.31919 7.19761Z" fill="currentColor" />
  </svg>
);

GardenBeet.propTypes = propTypes;

export default GardenBeet;
